import { motion, AnimatePresence } from "motion/react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { cn } from "@/lib/cn";
import { springSnappy } from "@/lib/motion";
import { useI18n } from "@/i18n";

/**
 * 亮版 / 暗版切換
 * ---------------------------------------------------------------
 * 用 AnimatePresence 讓兩個圖示交叉旋轉，而不是直接抽換 ——
 * 直接抽換會有一格空白，看起來像壞掉。
 *
 * 按鈕本身用 nm-pressable，按下去會凹進去，和全站的觸感一致。
 */
export default function ThemeToggle({ className }: { className?: string }) {
  const { t } = useI18n();
  const { resolved, toggle } = useTheme();
  const isDark = resolved === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      className={cn(
        "relative flex size-10 items-center justify-center overflow-hidden rounded-pill nm-pressable text-ink-soft hover:text-brand-800 dark:hover:text-brand-400",
        className,
      )}
      aria-label={isDark ? t("theme.toLight") : t("theme.toDark")}
      title={isDark ? t("theme.toLight") : t("theme.toDark")}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={resolved}
          initial={{ y: 14, opacity: 0, rotate: -45 }}
          animate={{ y: 0, opacity: 1, rotate: 0 }}
          exit={{ y: -14, opacity: 0, rotate: 45 }}
          transition={springSnappy}
          className="absolute inset-0 flex items-center justify-center"
        >
          {isDark ? <Moon className="size-[18px]" /> : <Sun className="size-[18px]" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
